const proxyServerUrl = process.env.VUE_APP_PROXY_SERVER

export async function getBanner() {
  const reqUrl = `${proxyServerUrl}/banner`

  var resp = await fetch(reqUrl, {
    method: "GET",
  })

  if(resp.status === 200) {
    return resp.url
  }
}